import {
    BrowserRouter,
    Routes,
    Route,
    Navigate
} from "react-router-dom";

import ProtectedRoute from "./ProtectedRoute";

import Layout from "../components/Layout";

import LoginPage from "../pages/LoginPage";
import Dashboard from "../pages/Dashboard";
import Menu from "../pages/Menu";
import Orders from "../pages/Orders";
import Financial from "../pages/Financial";
import Account from "../pages/Account";

export default function AppRoutes() {

    return (

        <BrowserRouter>

            <Routes>

                {/* PUBLIC */}
                <Route
                    path="/"
                    element={<LoginPage />}
                />

                <Route
                    path="/login"
                    element={<LoginPage />}
                />

                {/* PROTECTED LAYOUT */}
                <Route
                    element={
                        <ProtectedRoute>
                            <Layout />
                        </ProtectedRoute>
                    }
                >

                    <Route
                        path="/dashboard"
                        element={<Dashboard />}
                    />

                    <Route
                        path="/menu"
                        element={<Menu />}
                    />

                    <Route
                        path="/orders"
                        element={<Orders />}
                    />

                    <Route
                        path="/financial"
                        element={<Financial />}
                    />

                    <Route
                        path="/account"
                        element={<Account />}
                    />

                </Route>

                {/* FALLBACK */}
                <Route
                    path="*"
                    element={<Navigate to="/" />}
                />

            </Routes>

        </BrowserRouter>

    );

}
